import { Stack } from '@mui/material';
import { get, isArray, set } from 'lodash';
import React, { FC, ReactElement, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import MuiSnackbar from '../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import MUIToolTip from '../../../../components/ui-component/mui-tooltip/MUIToolTip';
import { DuplicateAntrag } from '../../../../lib/api/antrag';
import { PostRecord } from '../../../../lib/api/PostRecord';
import { APIS } from '../../../../lib/constants/apis';
import { ANTRAG_VERBUNDPARTNER } from '../../../../lib/constants/componentsPath';
import {
	ANTRAG_BUTTON_NAME,
	ANTRAG_TYP,
	ANTRAGS_ERFASSUNG_ART,
	ANTRAGS_FORMULAREN,
	ANTRAGS_STATUS,
	ART_DES_ANTRAGS,
	MITTEL_ABRUF_IST_ABGELEHNT_TEXT,
	MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT,
	NOCH_NICHT_MOEGLICH_TEXT,
	VN_ERSTELLUNG_NOCH_NICHT_MOEGLICH_TEXT,
} from '../../../../lib/constants/constant';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { enumT, isObjectEmpty } from '../../../../utils/helper';
import { AntragButton, AntragsButtonWrapper, getMonatListe } from '../FoerderungUebersicht';

// Import schema
import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from '../../../../lib/paths/kostenposition_FULL_Paths.json';
import MittelabrufSchema from '../../../../lib/paths/mittelabruf_FULL_Paths.json';
// import VerwendungsnachweisSchema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import {
	getMittelabrufBankdatenFromLastMittelabrufOrAntrag,
	getMittelabrufeFromProjektJahr,
	getMittelabrufErklaerungenUndAnlagenData,
} from 'src/utils/dashboardHelper';
// import ZwischenBerichtSchema from '../../../../lib/paths/zwischenbericht_FULL_Paths.json';
const P = Schema.attributes;
const MA_P = MittelabrufSchema.attributes;
// const VN_P = VerwendungsnachweisSchema.attributes;
// const ZB_P = ZwischenBerichtSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

const LoeweFoerderDashboard: FC<{ application: any; foerderProgramm: any }> = ({ application, foerderProgramm }) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [wsError, setWsError] = useState(false);

	const checkJahrCondition = false; // Set to true or false as needed
	const currentYear = new Date().getFullYear();

	const isSkizzeType = get(application, P.Allgemein_Typ.path) === ANTRAG_TYP.Skizze;
	const isFormantragType = get(application, P.Allgemein_Art_Des_Antrags.path) === ART_DES_ANTRAGS.Formantrag;
	const skizze =
		isSkizzeType ? application
		: isFormantragType ? get(application, P.urspruenglicher_Antrag.schema.attributes.Skizze.path)
		: get(application, P.Skizze.path);
	const antrag =
		isSkizzeType ? get(application, P.Skizze_Antrags.path, {})
		: isFormantragType ? get(application, P.urspruenglicher_Antrag.path, application)
		: application;
	const antragId = get(antrag, 'id');
	const formantrag = isFormantragType ? application : get(antrag, P.urspruenglicher_Antrag_Antrags.path);
	const formantragId = get(formantrag, 'id');
	const isDurchFormantragAbgeloest = get(antrag, P.Antragstatus_Antragstatus.path) === ANTRAGS_STATUS.durchFormantragAbgeloest;
	const isSkizzeExtern = useMemo(() => {
		return get(application, P.Allgemein_Erfassungsart.path, '') === ANTRAGS_ERFASSUNG_ART.Manuell;
	}, [application]);

	const projektDauer = get(formantrag, P.Allgemein_Projektdauerin_Jahren.path, 0);
	const projektJahrStart = get(formantrag, P.Allgemein_Projektstart_Jahr.path);

	const mittelAbruf = get(formantrag, P.Foerderantrag_Mittelabrufs.path, []);
	// const verwendungsnachweis = get(antrag, P.Foerderantrag_Verwendungsnachweiss.path, []);
	// const zwischenberichte = get(formantrag, P.Foerderantrag_Zwischenberichts.path, []);
	const abschlussbericht = get(formantrag, P.Foerderantrag_Abschlussberichts.path, []);

	const handleCreateFoerderAntrag = async () => {
		try {
			setLoading(true);
			const antragformlar = get(application, P.Allgemein_Antragsformular.path, '');
			let res = await DuplicateAntrag(get(application, 'id'), antragformlar, ANTRAG_TYP.Skizze, foerderProgramm);
			if (res) {
				navigate(`${PAGES_URLS.OnlineAntrag}`, {
					state: {
						id: get(res, 'data.id'),
						api: APIS.Antrag,
						antragsformular: get(res, `data.${P.Allgemein_Antragsformular.path}`),
					},
				});
			}
		} catch (err: any) {
			setWsError(true);
			console.error('ERROR: Creating Antrag ', err);
		} finally {
			setLoading(false);
		}
	};

	const handleCreateFormantrag = async () => {
		try {
			setLoading(true);
			const currentAntragId = get(antrag, 'id');
			if (!currentAntragId) {
				setWsError(true);
				return;
			}
			const antragformlar = get(antrag, P.Allgemein_Antragsformular.path, '');
			const updatedFormantrag = await DuplicateAntrag(
				currentAntragId,
				antragformlar,
				ANTRAG_TYP.Antrag,
				foerderProgramm,
				ART_DES_ANTRAGS.Formantrag,
			);
			if (updatedFormantrag) {
				navigate(`${PAGES_URLS.OnlineAntrag}`, {
					state: {
						id: get(updatedFormantrag, 'data.id'),
						api: APIS.Antrag,
						antragsformular: get(updatedFormantrag, `data.${P.Allgemein_Antragsformular.path}`),
					},
				});
			}
		} catch (err: any) {
			setWsError(true);
			console.error('ERROR: Creating Formantrag ', err);
		} finally {
			setLoading(false);
		}
	};
	const handleCreateMittelabruf = async (projektJahr: number) => {
		const foerderProgramm = get(formantrag, P.Foerderprogramm.path);
		const erklaerungenUndAnlagenData = getMittelabrufErklaerungenUndAnlagenData(foerderProgramm);
		const mittelabrufeImProjektJahr = getMittelabrufeFromProjektJahr(mittelAbruf, projektJahr);
		const summeVorangegangenerMittelabrufeImHaushaltsjahr = mittelabrufeImProjektJahr.reduce(
			(acc: number, curr: any) => acc + (Number(get(curr, MA_P.Ermittlung_Des_Auszahlungsbetrages_Bereits_Ausgezahlte_Mittel.path, 0)) || 0),
			0,
		);
		const MA_Data = {
			Foerderantrag: formantragId,
			Mittelabrufstatus_Mittelabrufstatus: ANTRAGS_STATUS.inBearbeitung,
			Allgemein_Haushaltsjahr: projektJahr,
			Allgemein_Abrufdatum: new Date(),
			// Bankdaten
			...getMittelabrufBankdatenFromLastMittelabrufOrAntrag(application),
			Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung: get(formantrag, P.Bewilligung_Jahresaufteilung.path, []).find(
				(ele: any) => get(ele, 'Projektjahr', '') === projektJahr,
			)?.Zuwendung,
			Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr: summeVorangegangenerMittelabrufeImHaushaltsjahr,
			Kalkulation_Block_1: [
				{
					Zelle_1: get(formantrag, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, ''),
					Zelle_2: get(formantrag, P.Antragstellende_Organisation_Foerderquote.path, []).find(
						(ele: any) => get(ele, 'Projektjahr') === projektJahr,
					)?.Foerderquote_403741,
				},
				...get(formantrag, P.Verbundpartner.path, [])
					.filter((ele: any) => get(ele, ANTRAG_VERBUNDPARTNER.Name, '') !== '')
					.map((eachVP: any) => {
						return {
							Zelle_1: get(eachVP, ANTRAG_VERBUNDPARTNER.Name, ''),
							Zelle_2: get(eachVP, ANTRAG_VERBUNDPARTNER.FoerderQuoteBlock, []).find((ele: any) => get(ele, 'Projektjahr') === projektJahr)
								?.Foerderquote_403741,
						};
					}),
			],
			...erklaerungenUndAnlagenData,
		};
		try {
			setLoading(true);
			let res = await PostRecord(APIS.Mittelabruf, { data: MA_Data });
			if (res) {
				navigate(`${PAGES_URLS.OnlineAntrag}`, { state: { id: get(res, 'data.id'), api: APIS.Mittelabruf } });
			}
		} catch (err: any) {
			setWsError(true);
			console.error('ERROR: Creating Mittelabruf ', err);
		} finally {
			setLoading(false);
		}
	};
	const handleCreateVerwendungsNachweis = async (projektJahr: number, currentMittelAbrufId: number) => {
		const allKostenPosition = get(antrag, P.Foerderantrag_Kostenpositions.path, []);
		const allVerbundPartner = get(antrag, P.Verbundpartner.path, []);
		const VN_DATA = {
			Allgemein_Haushaltsjahr: projektJahr,
			Verwendungsnachweisstatus_Status: ANTRAGS_STATUS.inBearbeitung,
			Foerderantrag: formantragId,
			Mittelabruf: currentMittelAbrufId,
			Allgemein_Foerderquote_Antragstellerin: get(formantrag, P.Antragstellende_Organisation_Foerderquote.path, []).find(
				(ele: any) => get(ele, 'Projektjahr') === projektJahr,
			)?.Foerderquote_403741,
			Allgemein_Foerderquote_Projektpartner: [
				...allVerbundPartner.map((eachVPartner: any) => {
					return {
						Partner: get(eachVPartner, 'Verbundpartner.id'),
						Partner_Quote: get(eachVPartner, ANTRAG_VERBUNDPARTNER.FoerderQuoteBlock, []).find(
							(ele: any) => get(ele, 'Projektjahr') === projektJahr,
						)?.Foerderquote_403741,
					};
				}),
			],
		};

		try {
			setLoading(true);
			const vnRes = await PostRecord(APIS.Verwendungsnachweis, { data: VN_DATA });
			if (vnRes) {
				for (let i = 0; i < allKostenPosition.length; i++) {
					const eachKP = allKostenPosition[i];
					const NW_DATA = {
						Allgemein_Nr: i + 1,
						Allgemein_Kostentraeger: get(eachKP, KP_P.Allgemein_Kostentraeger.path),
						Allgemein_Unternehmen_Institution: get(eachKP, `${KP_P.Unternehmen.path}.id`),
						Verwendungsnachweis: get(vnRes, 'data.id'),
						Allgemein_Kostenposition: get(eachKP, 'id'),
						Allgemein_Kostenart: get(eachKP, KP_P.Allgemein_Kostenposition.path),
						Allgemein_Bezeichnung: get(eachKP, KP_P.Allgemein_Bezeichnung.path),
						Kostennachweise_Nachweise: [{ Kommentar: '' }],
						Stundennachweis_Geleistete_Stunden: getMonatListe(eachKP),
					};
					await PostRecord(APIS.Nachweisposition, { data: NW_DATA });
				}
			}
		} catch (err: any) {
			console.error('ERROR: Creating Verwendungsnachweis ', err);
		} finally {
			setLoading(false);
			navigate(PAGES_URLS.OnlineAntrag, { state: { id: currentMittelAbrufId, api: APIS.Mittelabruf } });
		}
	};

	// ###########  Zwischenbericht erstmal ausgeblendet, da wir noch keine AFO von HA haben  ##############################
	// const handleCreateZwischenbericht = async () => {
	// 	let zbData = {
	// 		Foerderantrag: get(formantrag, 'id'),
	// 		Zwischenberichtstatus_Status: 'inBearbeitung',
	// 	};
	// 	try {
	// 		setLoading(true);
	// 		let res = await PostRecord(APIS.Zwischenbericht, { data: zbData });
	// 		if (res) navigate(`${PAGES_URLS.OnlineAntrag}`, { state: { id: get(res, 'data.id'), api: APIS.Zwischenbericht } });
	// 	} catch (err: any) {
	// 		setWsError(true);
	// 		console.error('ERROR: Creating Zwischenbericht ', err);
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// };

	const handleCreateAbschlussbericht = async () => {
		let ABData = {
			Foerderantrag: get(formantrag, 'id'),
			Abschlussberichtstatus_Abschlussberichtsstatus: ANTRAGS_STATUS.inBearbeitung,
			Antragsteller: get(formantrag, `${P.Antragstellende_Organisation.path}.id`),
		};
		if (get(formantrag, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.EmobFundE) {
			set(ABData, `Kurzfassung_Zum_Projektende.0.Kostentraeger`, 'Antragsteller');
			set(ABData, `Kurzfassung_Zum_Projektende.0.Antragsteller`, get(formantrag, `${P.Antragstellende_Organisation.path}.id`));

			set(ABData, `Effekte_Der_Foerderung_Im_Unternehmen.0.Kostentraeger`, 'Antragsteller');
			set(ABData, `Effekte_Der_Foerderung_Im_Unternehmen.0.Antragsteller`, get(formantrag, `${P.Antragstellende_Organisation.path}.id`));

			const allVpartnerAntrag = get(formantrag, P.Verbundpartner.path, []);
			for (let [index, eachVPartner] of allVpartnerAntrag.entries()) {
				set(ABData, `Kurzfassung_Zum_Projektende.${index + 1}.Kostentraeger`, 'Verbundpartner');
				set(ABData, `Kurzfassung_Zum_Projektende.${index + 1}.Verbundpartner`, get(eachVPartner, 'Verbundpartner.id'));
				set(ABData, `Effekte_Der_Foerderung_Im_Unternehmen.${index + 1}.Kostentraeger`, 'Verbundpartner');
				set(ABData, `Effekte_Der_Foerderung_Im_Unternehmen.${index + 1}.Verbundpartner`, get(eachVPartner, 'Verbundpartner.id'));
			}
		}
		try {
			setLoading(true);
			let res = await PostRecord(APIS.Abschlussbericht, { data: ABData });
			if (res) navigate(`${PAGES_URLS.OnlineAntrag}`, { state: { id: get(res, 'data.id'), api: APIS.Abschlussbericht } });
		} catch (err: any) {
			setWsError(true);
			console.error('ERROR: Creating Abschlussbericht ', err);
		} finally {
			setLoading(false);
		}
	};

	const RenderMittelAbrufButtons: FC<{}> = () => {
		const buttons: ReactElement[] = [];

		// Group Mittelabruf by Haushaltsjahr (project year)
		const groupedMittelabrufNachProjektJahr = mittelAbruf.reduce((acc: any, item: any) => {
			const year = item.attributes.Allgemein_Haushaltsjahr;
			if (!acc[year]) {
				acc[year] = [];
			}
			acc[year].push(item);
			return acc;
		}, {});

		// Loop through each year of the project duration
		for (let i = 0; i < projektDauer; i++) {
			const currentProjektJahr = projektJahrStart + i; // Determine current year

			// Check if there's any Mittelabruf for the current year
			const mittelabrufForYear = groupedMittelabrufNachProjektJahr[currentProjektJahr];

			// Determine whether the button to create Mittelabruf for this year should be enabled
			const isYearValidForCreation = checkJahrCondition ? currentProjektJahr === currentYear : true;

			// If there are Mittelabruf(s) for the year, show them
			if (mittelabrufForYear && mittelabrufForYear.length > 0) {
				// Checking if the last mittelabruf has the status "freigegeben"
				const isLastMittelFrei =
					(
						get(mittelabrufForYear[mittelabrufForYear.length - 1], MA_P.Mittelabrufstatus_Mittelabrufstatus.path, '') ===
							ANTRAGS_STATUS.freigegeben ||
						get(mittelabrufForYear[mittelabrufForYear.length - 1], MA_P.Mittelabrufstatus_Mittelabrufstatus.path, '') ===
							ANTRAGS_STATUS.abgelehnt
					) ?
						true
					:	false;
				let isMAErstellenButtonDisabled: boolean = false;
				if (isLastMittelFrei) {
					if (isMAErstellenButtonDisabled) {
						// if last mittelabruf is "freigegeben" but the current year is not valid then no MA can be created
						isMAErstellenButtonDisabled = true;
					} else {
						isMAErstellenButtonDisabled = false;
					}
				} else {
					// Disable the create button, if last MA for this year does not has the status "freigegeben"
					isMAErstellenButtonDisabled = true;
				}
				buttons.push(
					<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
						{mittelabrufForYear.map((eachMA: any, index: number) => {
							return (
								<AntragButton
									key={`mittelabruf-${currentProjektJahr}-${index}`}
									name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
									description={enumT(get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path))}
									onClick={() =>
										navigate(PAGES_URLS.OnlineAntrag, {
											state: {
												id: get(eachMA, 'id'),
												api: APIS.Mittelabruf,
											},
										})
									}
								/>
							);
						})}

						<MUIToolTip
							title='Sie können neuen Mittelabruf für das Jahr erstellen, sobald die vorherige Mittelabruf freigegeben ist'
							showTootip={isMAErstellenButtonDisabled}
						>
							<AntragButton
								name='Mittelabruf erstellen'
								description=''
								onClick={() => handleCreateMittelabruf(currentProjektJahr)}
								variant={'contained'}
								disabled={isMAErstellenButtonDisabled}
							/>
						</MUIToolTip>
					</AntragsButtonWrapper>,
				);
			} else {
				// If there are no Mittelabruf for the year, show the button to create a new one for a new year
				if (get(formantrag, P.Antragstatus_Antragstatus.path) === ANTRAGS_STATUS.inFoerderung) {
					buttons.push(
						<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
							<AntragButton
								name='Mittelabruf erstellen'
								description=''
								onClick={() => handleCreateMittelabruf(currentProjektJahr)}
								variant={'contained'}
								disabled={!isYearValidForCreation} // Disable if the year is not valid
							/>
						</AntragsButtonWrapper>,
					);
				} else {
					buttons.push(
						<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
							<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} disabled={true} />
						</AntragsButtonWrapper>,
					);
				}
			}
		}

		return <>{buttons}</>;
	};
	const RenderVerwendungsnachweisButtons: FC<{}> = () => {
		const buttons: ReactElement[] = [];

		// Group Mittelabruf by Haushaltsjahr (project year)
		const groupedMittelabrufNachProjektJahr = mittelAbruf.reduce((acc: any, item: any) => {
			const year = item.attributes.Allgemein_Haushaltsjahr;
			if (!acc[year]) {
				acc[year] = [];
			}
			acc[year].push(item);
			return acc;
		}, {});
		// Group Mittelabruf by Haushaltsjahr (project year)
		// const groupedVerwendungsnachweisNachProjektJahr = verwendungsnachweis.reduce((acc: any, item: any) => {
		// 	const year = get(item, VN_P.Allgemein_Haushaltsjahr.path);
		// 	if (!acc[year]) {
		// 		acc[year] = [];
		// 	}
		// 	acc[year].push(item);
		// 	return acc;
		// }, {});

		// Loop through each year of the project duration
		for (let i = 0; i < projektDauer; i++) {
			const currentProjektJahr = projektJahrStart + i; // Determine current year

			// Check if there's any Mittelabruf for the current year
			// const verwendungsnachweisForYear = groupedVerwendungsnachweisNachProjektJahr[currentProjektJahr];
			const mittelabrufForYear = groupedMittelabrufNachProjektJahr[currentProjektJahr];

			// Determine whether the button to create Verwendungsnachweis for this year shoul be enabled
			// const isYearValidForCreation = checkJahrCondition ? currentProjektJahr === currentYear : true;

			// If there are Mittelabruf(s) for the year, show them
			if (mittelabrufForYear && mittelabrufForYear.length > 0) {
				buttons.push(
					<AntragsButtonWrapper key={currentProjektJahr} title={'Verwendungsnachweis für ' + currentProjektJahr}>
						{mittelabrufForYear.map((eachMA: any, index: number) => {
							if (!isObjectEmpty(get(eachMA, MA_P.Mittelabruf_Verwendungsnachweiss.path, {}))) {
								// Wenn VN in MA gibt, wird diese button angezeigt, welche zu Antrag navigiert
								return (
									<AntragButton
										key={`vn-${currentProjektJahr}-${index}`}
										name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
										description={enumT(
											get(eachMA, MA_P.Mittelabruf_Verwendungsnachweiss.schema.attributes.Verwendungsnachweisstatus_Status.path),
										)}
										onClick={() =>
											navigate(PAGES_URLS.OnlineAntrag, {
												state: {
													id: get(eachMA, 'id'),
													api: APIS.Mittelabruf,
												},
											})
										}
									/>
								);
							} else {
								// wenn noch kein VN zu MA gibt. Werden die VNs button abhängig vom MA-Status angezeigt
								if (get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path) === ANTRAGS_STATUS.abgelehnt) {
									// Kein VN ist erförderlich, da MA abgelehnt wurde
									return (
										<MUIToolTip title={MITTEL_ABRUF_IST_ABGELEHNT_TEXT}>
											<AntragButton
												key={`vn-${currentProjektJahr}-${index}`}
												name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
												description={'Nicht möglich'}
												onClick={() => {}}
												disabled={true}
											/>
										</MUIToolTip>
									);
								} else if (get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path) !== ANTRAGS_STATUS.inBearbeitung) {
									// VN-Erstellung im Portal für LOEWE noch nicht umgesetzt -> Button vorerst deaktiviert.
									// handleCreateVerwendungsNachweis bleibt verdrahtet und wird bei Umsetzung des LOEWE-VN wieder aktiviert; disabled Buttons feuern nicht.
									return (
										<MUIToolTip title={VN_ERSTELLUNG_NOCH_NICHT_MOEGLICH_TEXT} showTootip={true}>
											<AntragButton
												key={`vn-erstellen-${currentProjektJahr}-${index}`}
												name='Verwendungsnachweis erstellen'
												description=''
												onClick={() => handleCreateVerwendungsNachweis(currentProjektJahr, get(eachMA, 'id'))}
												variant={'contained'}
												disabled={true}
											/>
										</MUIToolTip>
									);
								} else {
									// VN erstellen noch nicht möglich, weil MA noch in Bearbeitung ist.
									return (
										<MUIToolTip title={MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT}>
											<AntragButton
												key={`vn-${currentProjektJahr}-${index}`}
												name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
												description={'erstellen'}
												onClick={() => {}}
												disabled={true}
											/>
										</MUIToolTip>
									);
								}
							}
						})}
						{/* Diese ist ein Platzhalter Button, der immer disabled ist.  */}
						<MUIToolTip title={MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT}>
							<AntragButton name='Verwendungsnachweis erstellen' description='' onClick={() => {}} disabled={true} variant={'contained'} />
						</MUIToolTip>
					</AntragsButtonWrapper>,
				);
			} else {
				// Platzhalter Button für jedes Jahr, der immer disabled ist.
				buttons.push(
					<AntragsButtonWrapper key={currentProjektJahr} title={'Verwendungsnachweis für ' + currentProjektJahr}>
						<MUIToolTip title={MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT}>
							<AntragButton name='Verwendungsnachweis erstellen' description='' onClick={() => {}} disabled={true} variant={'contained'} />
						</MUIToolTip>
					</AntragsButtonWrapper>,
				);
			}
		}

		return <>{buttons}</>;
	};
	// ##########  Zwischenbericht erstmal ausgeblendet, da wir noch keine AFO von HA haben  ##############################
	// const RenderZwischenBerichtButtons: FC<{}> = () => {
	// 	const znErstellungInterval = MEDIAN_INTERVAL.halbjaehrlich;
	// 	const monthInterval = Math.ceil(12 / znErstellungInterval);
	// 	const totalPossibleReports = projektDauer * znErstellungInterval;
	// 	const areReportsFull = zwischenberichte.length >= totalPossibleReports;

	// 	// Function to determine if a create button should be active
	// 	const isCreateButtonActive = (reportIndex: number, yearIndex: number) => {
	// 		const reportYear = projektJahrStart + yearIndex;
	// 		const isCurrentYear = checkJahrCondition ? reportYear === currentYear : true;
	// 		return !areReportsFull && reportIndex === zwischenberichte.length && isCurrentYear;
	// 	};

	// 	return (
	// 		<AntragsButtonWrapper title='Zwischenbericht:'>
	// 			{zwischenberichte.length > 0 ?
	// 				<>
	// 					{Array.from({ length: projektDauer }).map((_, yearIndex) => (
	// 						<Stack direction='row' justifyContent='space-between' key={yearIndex} spacing={2}>
	// 							{Array.from({ length: znErstellungInterval }).map((_, buttonIndex) => {
	// 								const monthIndex = (buttonIndex + 1) * monthInterval - 1;
	// 								const monthName = MONAT_LISTE[monthIndex]?.Monat || 'Unbekannter Monat';
	// 								const reportIndex = yearIndex * znErstellungInterval + buttonIndex;

	// 								if (reportIndex < zwischenberichte.length) {
	// 									return (
	// 										<AntragButton
	// 											key={`report-${yearIndex}-${buttonIndex}`}
	// 											name={`${projektJahrStart + yearIndex} für Ende ${monthName}`}
	// 											description={`Status: ${enumT(get(zwischenberichte, `${reportIndex}.${ZB_P.Zwischenberichtstatus_Status.path}`))}`}
	// 											onClick={() => {
	// 												navigate(`${PAGES_URLS.OnlineAntrag}`, {
	// 													state: { id: get(zwischenberichte, `${reportIndex}.id`), api: APIS.Zwischenbericht },
	// 												});
	// 											}}
	// 										/>
	// 									);
	// 								} else {
	// 									return (
	// 										<AntragButton
	// 											key={`erstellen-${yearIndex}-${buttonIndex}`}
	// 											name={`${projektJahrStart + yearIndex} für Ende ${monthName}`}
	// 											description=''
	// 											onClick={handleCreateZwischenbericht}
	// 											variant={'contained'}
	// 											disabled={!isCreateButtonActive(reportIndex, yearIndex)}
	// 										/>
	// 									);
	// 								}
	// 							})}
	// 						</Stack>
	// 					))}
	// 				</>
	// 			:	<>
	// 					{get(formantrag, P.Antragstatus_Antragstatus.path) !== ANTRAGS_STATUS.inFoerderung ?
	// 						<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} disabled={true} />
	// 					:	<>
	// 							{Array.from({ length: projektDauer }).map((_, yearIndex) => (
	// 								<Stack direction='row' justifyContent='space-between' key={yearIndex} spacing={2}>
	// 									{Array.from({ length: znErstellungInterval }).map((_, buttonIndex) => {
	// 										const monthIndex = (buttonIndex + 1) * monthInterval - 1;
	// 										const monthName = MONAT_LISTE[monthIndex]?.Monat || 'Unbekannter Monat';
	// 										const reportIndex = yearIndex * znErstellungInterval + buttonIndex;

	// 										return (
	// 											<AntragButton
	// 												key={`erstellen-${yearIndex}-${buttonIndex}`}
	// 												name={`${projektJahrStart + yearIndex} für Ende ${monthName}`}
	// 												description=''
	// 												onClick={handleCreateZwischenbericht}
	// 												variant={'contained'}
	// 												disabled={!isCreateButtonActive(reportIndex, yearIndex)}
	// 											/>
	// 										);
	// 									})}
	// 								</Stack>
	// 							))}
	// 						</>
	// 					}
	// 				</>
	// 			}
	// 		</AntragsButtonWrapper>
	// 	);
	// };
	const RenderAbschlussberichtButton: FC<{}> = () => {
		if (isArray(abschlussbericht) && abschlussbericht.length > 0) {
			return (
				<AntragsButtonWrapper title='Abschlussbericht:'>
					{abschlussbericht.map((eachAbschlussbericht: any, i: number) => {
						return (
							<AntragButton
								key={i}
								name='Abschlussbericht'
								description='Ansehen'
								onClick={() =>
									navigate(`${PAGES_URLS.OnlineAntrag}`, {
										state: { id: get(eachAbschlussbericht, 'id'), api: APIS.Abschlussbericht },
									})
								}
							/>
						);
					})}
				</AntragsButtonWrapper>
			);
		} else {
			if (get(formantrag, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.ProjektBeendet) {
				return (
					<AntragsButtonWrapper title='Abschlussbericht:'>
						<AntragButton
							name='Abschlussbericht'
							description='Abschlussbericht erstellen'
							onClick={handleCreateAbschlussbericht}
							variant='text'
						/>
					</AntragsButtonWrapper>
				);
			} else {
				return (
					<AntragsButtonWrapper title='Abschlussbericht:'>
						<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} variant='text' disabled={true} />
					</AntragsButtonWrapper>
				);
			}
		}
	};

	return (
		<>
			<LoadingBackdrop open={loading} />
			<MuiSnackbar showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage='Etwas ist schief gelaufen' />
			{/* Antrag und Skizze */}
			<Stack direction={'row'} justifyContent={'space-between'} alignItems='flex-start'>
				<AntragsButtonWrapper title='Skizze:'>
					<AntragButton
						name={get(skizze, P.Allgemein_Projekttitel.path) ? get(skizze, P.Allgemein_Projekttitel.path) : ANTRAG_BUTTON_NAME}
						description={enumT(get(skizze, P.Antragstatus_Antragstatus.path))}
						onClick={() =>
							navigate(PAGES_URLS.OnlineAntrag, {
								state: {
									id: get(skizze, 'id'),
									api: APIS.Antrag,
									antragsformular: get(skizze, P.Allgemein_Antragsformular.path),
								},
							})
						}
						disabled={isSkizzeExtern}
					/>
				</AntragsButtonWrapper>

				<Stack spacing={2}>
					{antragId ?
						<AntragsButtonWrapper title='Antrag:'>
							<AntragButton
								name={get(antrag, P.Allgemein_Projekttitel.path) ? get(antrag, P.Allgemein_Projekttitel.path) : ANTRAG_BUTTON_NAME}
								description={enumT(get(antrag, P.Antragstatus_Antragstatus.path))}
								onClick={() =>
									navigate(`${PAGES_URLS.OnlineAntrag}`, {
										state: {
											id: antragId,
											api: APIS.Antrag,
											antragsformular: get(antrag, P.Allgemein_Antragsformular.path),
										},
									})
								}
							/>
						</AntragsButtonWrapper>
					: get(skizze, P.Antragstatus_Antragstatus.path) === 'EmpfehlungZurAntragstellung' ?
						<AntragsButtonWrapper title='Antrag:'>
							<AntragButton name={'Antrag erstellen'} description={''} onClick={handleCreateFoerderAntrag} variant={'contained'} />
						</AntragsButtonWrapper>
					:	<AntragsButtonWrapper title='Antrag:'>
							<AntragButton name={'Noch nicht möglich'} description={''} onClick={() => {}} disabled={true} />
						</AntragsButtonWrapper>
					}

					{!antragId ?
						<AntragsButtonWrapper title='Formantrag:'>
							<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description={''} onClick={() => {}} disabled={true} />
						</AntragsButtonWrapper>
					: formantrag ?
						<AntragsButtonWrapper title='Formantrag:'>
							<AntragButton
								name={get(formantrag, P.Allgemein_Projekttitel.path) || ANTRAG_BUTTON_NAME}
								description={enumT(get(formantrag, P.Antragstatus_Antragstatus.path))}
								onClick={() =>
									navigate(`${PAGES_URLS.OnlineAntrag}`, {
										state: {
											id: get(formantrag, 'id'),
											api: APIS.Antrag,
											antragsformular: get(formantrag, P.Allgemein_Antragsformular.path),
										},
									})
								}
							/>
						</AntragsButtonWrapper>
					:	<AntragsButtonWrapper title='Formantrag:'>
							<AntragButton
								name={'Formantrag erstellen'}
								description={''}
								onClick={handleCreateFormantrag}
								variant={'contained'}
								disabled={!isDurchFormantragAbgeloest}
							/>
						</AntragsButtonWrapper>
					}
				</Stack>
			</Stack>

			{/* Mittelabruf und Verwendungsnachweis */}
			<Stack direction='row' spacing={2} justifyContent={'space-between'}>
				<span>
					<RenderMittelAbrufButtons />
				</span>
				<span>
					<RenderVerwendungsnachweisButtons />
				</span>
			</Stack>

			{/* <RenderZwischenBerichtButtons /> */}
			<RenderAbschlussberichtButton />
		</>
	);
};

export default LoeweFoerderDashboard;
